// Runtime polyfills the mobile bundle gets from the React Native runtime.
// Imported first from main.tsx.

import { Buffer } from 'buffer';

const g = globalThis as unknown as Record<string, unknown>;

if (!g.Buffer) g.Buffer = Buffer;
if (!g.global) g.global = globalThis;

// `__DEV__` is injected by DefinePlugin at build time; this guard only
// matters if the bundle is ever evaluated outside the Rspack pipeline.
if (typeof (g as { __DEV__?: boolean }).__DEV__ === 'undefined') {
  (g as { __DEV__?: boolean }).__DEV__ = true;
}
